import React from 'react'
import { useTranslation } from 'react-i18next';

import { PROJECT } from '../../constants';

import LogoVIVECreate from '../../images/logo-vive-create.svg';
import LOGOVG from '../../images/logo-vg.png';

import './header.scss';

const headerH = 60;

const Header = () => {
    const { t } = useTranslation();

    const scrollToRow = (elemId) => {
        const offsetTop =  document.querySelector('#' + elemId).offsetTop;
        window.scrollTo({
            top: offsetTop - headerH,
            behavior: 'smooth'
        });
    }

    const  content = PROJECT === 'vg' ?
    {
        logo: LOGOVG,
        top: t('btnTop_vg'),
        feature: t('btnKeyFeature_vg'),
        video: t('btnIntroVideo_vg'),
        start: '',
        download: t('btnDownload_vg'),

    } :
    {
        logo: LogoVIVECreate,
        top: t('btnTop'),
        feature: t('btnKeyFeature'),
        video: t('btnIntroVideo'),
        start: t('btnGetStart'),
        download: '',
    };

    return (
        <div className="header-wrap">
            <div className="header">
                <div className="logo-wrap">
                    <img src={content.logo} alt='logo'/>
                </div>
                <div className="nav-wrap">
                    <button className='nav-item' onClick={() => {scrollToRow('top_intro')}}>{content.top}</button>
                    <button className='nav-item' onClick={() => {scrollToRow('key_feature')}}>{content.feature}</button>
                    {PROJECT === 'create' && <button className='nav-item' onClick={() => {scrollToRow('get_start')}}>{content.start}</button>}
                    <button className='nav-item' onClick={() => {scrollToRow('intro_video')}}>{content.video}</button>
                    {PROJECT === 'vg' && <button className='nav-item' onClick={() => {scrollToRow('download')}}>{content.download}</button>}
                </div>
            </div>
        </div>        
    )
}

export default Header;
